export default "__VITE_ASSET__05f80908__"